import { http } from '../../config/axios'

export default function putServico(servico: any): Promise<string> {
  return http
    .put('api/servico', servico)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put servico', error)
      throw Error(error.response.data)
    })
}
